import { types } from "../actions/types";

const initialState = {
    option: null,
    section: 'fitness'
}

export const navigatorReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.updateNavigator:
            return { ...state, ...action.payload };
        case types.updateCurrentSection:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};